import React from 'react';

const Spacer = ({ size, horizontal = false }) => {
  let space = 0;

  switch (size) {
    case 'xxs':
      space = 5;
      break;
    case 'xs':
      space = 10;
      break;
    case 's':
      space = 15;
      break;
    case 'm':
      space = 20;
      break;
    case 'l':
      space = 25;
      break;
    case 'xl':
      space = 30;
      break;
    case 'xxl':
      space = 35;
      break;
    case 'xxxl':
      space = 40;
      break;
    case 'xxxxl':
      space = 45;
      break;
    case '5xl':
      space = 60;
      break;
    case '6xl':
      space = 80;
      break;

    default:
      break;
  }

  const style = {};

  if (horizontal) {
    style.width = space;
  } else {
    style.height = space;
    style.width = '100%';
  }

  return ( <div style={style} />);
}

export default Spacer;